import * as React from 'react';

function HomeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.333 10.85v-.023a.2.2 0 0 0-.018-.095l-.004-.01-.005-.009a.3.3 0 0 0-.085-.097l-.065-.052-6.79-6.826-.029-.032a.48.48 0 0 0-.313-.158.5.5 0 0 0-.332.11l-.029.03-.032.037-6.783 6.818-.031.028a.48.48 0 0 0-.158.305v9.017q0 .123.043.23a.53.53 0 0 0 .48.322h2.93V17.79c0-2.065 1.68-3.976 3.813-3.976 1.044 0 2.052.41 2.801 1.122l.015.014.014.015c.386.387.663.833.853 1.292l.007.017.007.016c.184.477.277.992.267 1.517v2.643h2.937c.12 0 .25-.051.351-.155l.006-.005.006-.006a.54.54 0 0 0 .152-.384zm1.508 9.051c0 .542-.207 1.06-.589 1.443a2 2 0 0 1-1.426.608h-4.437v-4.16a2.5 2.5 0 0 0-.166-.959 2.5 2.5 0 0 0-.531-.808 2.58 2.58 0 0 0-1.767-.709c-1.219 0-2.314 1.15-2.314 2.476v4.152H5.183a2.02 2.02 0 0 1-1.874-1.267c-.1-.25-.15-.517-.15-.784v-9.079a1.98 1.98 0 0 1 .655-1.359l6.718-6.753c.058-.066.116-.125.182-.183.399-.334.904-.5 1.419-.467.514.042.987.275 1.327.659l6.7 6.736c.208.167.382.375.498.617.125.25.183.533.174.809z"
  }));
}

export { HomeIcon };
